<template>
  <div id="map"></div>
</template>
<script>
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {fromLonLat} from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import {Icon, Style} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';

export default {
  mounted() {
    const lonLat = [23.040732, 54.955703]
    const addr = new Feature({
      geometry: new Point(fromLonLat([23.040722, 54.955820])),
    });
    addr.setStyle(
      new Style({
        image: new Icon({
          color: '#ff0000',
          crossOrigin: 'anonymous',
          imgSize: [35, 35],
          src: 'assets/pin.svg',
        }),
      })
    );
    const vectorSource = new VectorSource({
      features: [addr],
    });
    var vectorLayer = new VectorLayer({
      source: vectorSource,
    });
    new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        vectorLayer
      ],
      view: new View({
        center: fromLonLat(lonLat),
        zoom: 17
      })
    })
  }
}
</script>

<style>
#map {
  display: block;
  height: 300px;
  width: 100%;
}
</style>